export function normalizeIdentity (value) {
  if (value === undefined || value === null) return null
  const prepared = String(value).replace(/\s/g, '').trim()
  return prepared || null
}
